import React, { useEffect, useRef, useState } from 'react';
import styled, { useTheme } from 'styled-components';
import { FilterAdapter, useUrlFilterController } from 'app/components/filters/url-filters';

export const MarketplaceNameAdapter: FilterAdapter<string> = {
  key: 'name',
  fromUrl: (sp) => sp.get('name') || null,
  toUrl: (sp, value) => {
    const next = new URLSearchParams(sp.toString());
    if (!value) {
      next.delete('name');
    } else {
      next.set('name', value);
    }
    return next;
  },
  toKey: (v) => `name:${v ?? ''}`
};

const StyledNameInput = styled.input(({ theme }) =>
  theme.withMedia({
    background: theme.styleguideColors.fillSecondary,
    border: 'none',
    borderRadius: '4px',
    fontSize: '14px',
    padding: '9px 12px',
    color: theme.styleguideColors.contentPrimary,
    outline: 'none',
    minWidth: '200px',
    '::placeholder': {
      color: theme.styleguideColors.contentSecondary
    }
  })
);

const MIN_CHARS = 3;
const DEBOUNCE_MS = 400;

export const MarketplaceNameFilter = () => {
  const ctl = useUrlFilterController();
  const committed = ctl.get(MarketplaceNameAdapter) ?? '';
  const [draft, setDraft] = useState(committed);
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  // sync if URL resets externally
  useEffect(() => {
    setDraft(committed);
  }, [committed]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const val = e.target.value;
    setDraft(val);
    if (timerRef.current) clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => {
      ctl.set(MarketplaceNameAdapter, val.length >= MIN_CHARS ? val : null);
    }, DEBOUNCE_MS);
  };

  return (
    <StyledNameInput
      type="text"
      value={draft}
      onChange={handleChange}
      placeholder="Search by name…"
    />
  );
};
